"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "lots-list"
  }, [_c("b-input", {
    attrs: {
      placeholder: "Buscar lotes por código ou variedade...",
      icon: "magnify",
      "icon-clickable": ""
    },
    model: {
      value: _vm.searchQuery,
      callback: function callback($$v) {
        _vm.searchQuery = $$v;
      },
      expression: "searchQuery"
    }
  }), _vm._v(" "), _c("b-table", {
    attrs: {
      data: _vm.lots,
      loading: _vm.isLoading,
      selected: _vm.selectedLot,
      striped: "",
      hoverable: "",
      "mobile-cards": ""
    },
    on: {
      "update:selected": function updateSelected($event) {
        _vm.selectedLot = $event;
      },
      click: _vm.handleRowClick
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function fn() {
        return [_c("div", {
          staticClass: "has-text-centered"
        }, [_vm.searchQuery ? _c("p", [_vm._v('\n          Nenhum lote encontrado para "' + _vm._s(_vm.searchQuery) + '"\n        ')]) : _c("p", [_vm._v("\n          Nenhum lote disponível\n        ")])])];
      },
      proxy: true
    }])
  }, [_c("b-table-column", {
    attrs: {
      field: "code",
      label: "Nome"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.code) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "type",
      label: "Tipo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatType(props.row)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "stage",
      label: "Estágio"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatStage(props.row)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "rootstock",
      label: "Cavalo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$rootstock;
        return [_vm._v("\n      " + _vm._s(((_props$row$rootstock = props.row.rootstock) === null || _props$row$rootstock === void 0 ? void 0 : _props$row$rootstock.name) || "--") + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "scion",
      label: "Copa"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$scion;
        return [_vm._v("\n      " + _vm._s(((_props$row$scion = props.row.scion) === null || _props$row$scion === void 0 ? void 0 : _props$row$scion.name) || "--") + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "variety",
      label: "Variedade"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatVarietyName(props.row)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "place",
      label: "Local"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm.formatPlaces(props.row).length ? _c("div", {
          staticClass: "lot-places"
        }, _vm._l(_vm.formatPlaces(props.row), function (place, index) {
          return _c("div", {
            key: "".concat(props.row.id, "-").concat(index),
            staticClass: "lot-place"
          }, [_vm._v("\n          " + _vm._s(place) + "\n        ")]);
        }), 0) : _c("span", [_vm._v("--")])];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "plantedAt",
      label: "Data"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatDate(props.row.plantedAt)) + "\n    ")];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;